export default "__VITE_ASSET__CB5nDX8k__"